<template>
  <div class="recharge-page">
    <el-card class="box-card">
      <div class="header-actions">
        <h2 class="recharge-title">账户充值</h2>
        <el-button @click="returnToCenter" size="small">返回个人中心</el-button>
      </div>
      
      <el-card class="box-card" style="margin-top: 20px;">
        <el-form :model="rechargeForm" :rules="rechargeRules" ref="rechargeForm" label-width="100px">
          <el-form-item label="选择套餐" prop="packageId" required>
            <el-select
              v-model="rechargeForm.packageId" 
              placeholder="请选择VIP套餐" 
              style="width: 300px;"
              disabled
              @change="onPackageChange"
              value-key="id">
              <el-option
                v-for="pkg in vipPackages"
                :key="pkg.id"
                :label="`${pkg.name} - ${pkg.price}元 (${pkg.duration}个月)`"
                :value="pkg.id">
                <span style="float: left">{{ pkg.name }}</span>
                <span style="float: right; color: #F56C6C; font-weight: bold; margin-left: 20px;">￥{{ pkg.price }}</span>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="充值金额" prop="amount" required>
            <el-input 
              v-model="rechargeForm.amount" 
              placeholder="请选择套餐"
              disabled
              style="width: 300px;">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>

          <el-form-item label="支付方式" prop="paymentType" required>
            <el-radio-group v-model="rechargeForm.paymentType">
              <el-radio :label="2">
                <i class="el-icon-wallet" style="color: #1677FF;"></i> 支付宝
              </el-radio>
              <el-radio :label="1">
                <i class="el-icon-chat-dot-round" style="color: #07C160;"></i> 微信支付
              </el-radio>

<!--              <el-radio :label="3">-->
<!--                <i class="el-icon-wallet" style="color: #07C160;"></i> 银联支付-->
<!--              </el-radio>-->
            </el-radio-group>
          </el-form-item>

          <el-form-item label="套餐说明" v-if="selectedPackage">
            <div class="package-info">
              <p><strong>套餐名称：</strong>{{ selectedPackage.name }}</p>
              <p><strong>有效期：</strong>{{ selectedPackage.duration }}个月</p>
              <p><strong>查看记录：</strong>{{ selectedPackage.viewRecords }}次</p>
              <p v-if="selectedPackage.description"><strong>说明：</strong>{{ selectedPackage.description }}</p>
            </div>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitRecharge" :loading="rechargeLoading">立即充值</el-button>
          </el-form-item>
        </el-form>
      </el-card>

      <!-- 交易记录 -->
      <el-card class="box-card" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
          <span style="font-weight: bold; font-size: 16px;">交易记录（只展示前十条）</span>
          <el-button style="float: right;" size="small" @click="loadTransactionRecords">刷新</el-button>
        </div>
        <el-table :data="transactionRecords" v-loading="transactionLoading">
          <el-table-column prop="createdAt" label="时间"></el-table-column>
          <el-table-column prop="packageName" label="充值套餐">
          </el-table-column>
          <el-table-column prop="amount" label="金额">
            <template slot-scope="scope">
              <span style="color: #67C23A; font-weight: bold;">{{ scope.row.amount }}元</span>
            </template>
          </el-table-column>
          <el-table-column prop="paymentType" label="支付方式">
            <template slot-scope="scope">
              <template  v-if="scope.row.paymentType === 1">
                微信支付
              </template>
              <template v-if="scope.row.paymentType === 2">
                支付宝支付
              </template>
              <template v-if="scope.row.paymentType === 3">
                其他支付
              </template>
            </template>

          </el-table-column>
<!--          <el-table-column prop="description" label="说明"></el-table-column>-->
          <el-table-column prop="status" label="状态" >
            <template slot-scope="scope">
              <el-tag size="small" :type="getStatusType(scope.row.status)">
                <template v-if="scope.row.status === 0">
                  未支付
                </template>
                <template v-else-if="scope.row.status === 1">
                  已支付
                </template>
                <template v-else-if="scope.row.status === 2">
                  已取消
                </template>
              </el-tag>
            </template>
          </el-table-column>
<!--          <el-table-column label="操作" width="150" fixed="right">-->
<!--            <template slot-scope="scope">-->
<!--              <el-button -->
<!--                v-if="scope.row.status === '待支付'" -->
<!--                type="text" -->
<!--                size="small"-->
<!--                @click="checkOrderStatus(scope.row.orderId)">-->
<!--                查询状态-->
<!--              </el-button>-->
<!--              <el-button -->
<!--                v-if="scope.row.status === '待支付'" -->
<!--                type="text" -->
<!--                size="small"-->
<!--                style="color: #F56C6C;"-->
<!--                @click="cancelOrder(scope.row.orderId)">-->
<!--                取消订单-->
<!--              </el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
      </el-card>
    </el-card>

    <!-- 支付二维码对话框 -->
    <el-dialog
      title="扫码支付"
      :visible.sync="paymentDialogVisible"
      width="450px"
      center
      :close-on-click-modal="false"
      @close="stopPolling">
      <div class="payment-dialog-content" v-if="currentOrder">
        <div class="payment-info">
          <p><strong>订单号：</strong>{{ currentOrder.orderNo }}</p>
          <p><strong>支付金额：</strong><span style="color: #F56C6C; font-size: 24px; font-weight: bold;">￥{{ currentOrder.amount }}</span></p>
          <p><strong>支付方式：</strong>
            <template v-if="currentOrder.paymentType === 1">
              微信支付
            </template>
            <template v-if="currentOrder.paymentType === 2">
              支付宝
            </template>
<!--            <template v-if="currentOrder.paymentType === 3">-->
<!--              银联支付-->
<!--            </template>-->
<!--            {{ currentOrder.paymentType === 1 ? '微信支付' : '支付宝' }}-->
          </p>
        </div>
        
        <div class="qrcode-container">
          <div v-if="currentOrder.paymentType === 2" v-html="currentOrder.form"></div>
          <div v-else class="qrcode-wrapper">
            <div id="qrcode" ref="qrcode"></div>
            <p style="margin-top: 10px; color: #909399;">
              <template v-if="currentOrder.paymentType === 1">请使用微信扫一扫</template>
<!--              <template v-else-if="currentOrder.paymentType === 3">请使用云闪付扫一扫</template>-->
            </p>
          </div>
        </div>
        
        <div class="payment-tips">
          <i class="el-icon-info"></i>
          <span>{{ pollingMessage }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelCurrentOrder">取消支付</el-button>
        <el-button type="primary" @click="checkPaymentStatus">查询支付状态</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import QRCode from 'qrcodejs2';

export default {
  name: 'RechargeView',
  data() {
    return {
      rechargeLoading: false,
      transactionLoading: false,
      packagesLoading: false,
      rechargeForm: {
        packageId: null,
        packageName: '',
        amount: '',
        paymentType: 2 // 默认支付宝
      },
      rechargeRules: {
        packageId: [
          { required: true, message: '请选择VIP套餐', trigger: 'change' }
        ],
        amount: [
          { required: true, message: '请选择套餐', trigger: 'blur' }
        ],
        paymentType: [
          { required: true, message: '请选择支付方式', trigger: 'change' }
        ]
      },
      transactionRecords: [],
      vipPackages: [], // VIP套餐列表
      selectedPackage: null, // 选中的套餐
      paymentDialogVisible: false, // 支付对话框显示状态
      currentOrder: null, // 当前订单信息
      pollingTimer: null, // 轮询定时器
      pollingCount: 0, // 轮询次数
      pollingMessage: '支付完成后会自动跳转...'
    };
  },
  created() {
    // 加载VIP套餐列表
    this.loadVipPackages();
    
    // 从路由参数中获取套餐信息（如果有）
    if (this.$route.query.packageId) {
      this.rechargeForm.packageId = parseInt(this.$route.query.packageId);
    }
    if (this.$route.query.amount) {
      this.rechargeForm.amount = this.$route.query.amount;
    }
    
    // 加载交易记录
    this.loadTransactionRecords();
    
    // 检查是否从支付宝返回（用户可能已完成支付）
    if (this.$route.query.from === 'alipay') {
      this.$message.info('请查看交易记录确认支付状态');
      // 延迟刷新交易记录，等待回调处理完成
      setTimeout(() => {
        this.loadTransactionRecords();
      }, 2000);
    }
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    this.stopPolling();
  },
  methods: {
    // 返回个人中心
    returnToCenter() {
      this.$router.push('/center');
    },
    
    // 加载VIP套餐列表
    async loadVipPackages() {
      this.packagesLoading = true;
      try {
        const res = await request.get('/vip/packages/list');
        if (res.code == 200) {
          this.vipPackages = res.data || [];
          
          // 如果路由参数中有packageId，自动选择对应套餐
          if (this.$route.query.packageId) {
            const packageId = this.$route.query.packageId;
            this.rechargeForm.packageId = packageId;
            // 如果有传递packageName，也设置
            if (this.$route.query.packageName) {
              this.rechargeForm.packageName = this.$route.query.packageName;
            }
            
            this.onPackageChange(packageId);
          }
        } else {
          this.$message.error(res.msg || '获取套餐列表失败');
        }
      } catch (error) {
        // console.error('加载套餐列表失败:', error);
        this.$message.error('获取套餐列表失败');
      } finally {
        this.packagesLoading = false;
      }
    },
    
    // 套餐选择变化
    onPackageChange(packageId) {
      const pkg = this.vipPackages.find(p => p.id === packageId);
      if (pkg) {
        this.selectedPackage = pkg;
        this.rechargeForm.amount = pkg.price;
        this.rechargeForm.packageName = pkg.name;
      }
    },
    
    // 加载交易记录
    async loadTransactionRecords() {
      this.transactionLoading = true;
      try {
        const res = await request.get('/payment/order/my');
        if (res.code === '200') {
          this.transactionRecords = res.data || [];
        } else {
          this.$message.error(res.msg || '获取交易记录失败');
        }
      } catch (error) {
        // console.error('加载交易记录失败:', error);
        this.$message.error('获取交易记录失败');
      } finally {
        this.transactionLoading = false;
      }
    },
    
    // 提交充值
    submitRecharge() {
      this.$refs.rechargeForm.validate(async (valid) => {
        if (valid) {
          this.rechargeLoading = true;
          try {
            // 调用创建支付订单接口
            const res = await request.post('/payment/order/create', {
              packageId: this.rechargeForm.packageId,
              paymentType: this.rechargeForm.paymentType,
              packageType: 'VIP'
            });
            
            if (res.code == 200) {
              // 设置当前订单信息
              this.currentOrder = {
                orderNo: res.data.orderNo,
                amount: this.rechargeForm.amount,
                paymentType: this.rechargeForm.paymentType,
                codeUrl: res.data.codeUrl,
                form: res.data.form
              };
              
              // 刷新交易记录
              this.loadTransactionRecords();
              
              // 支付宝支付：直接提交表单跳转
              if (this.rechargeForm.paymentType === 2) {
                this.$message.success('订单创建成功，即将跳转到支付宝支付页面...');
                
                // 渲染并自动提交支付宝表单
                this.$nextTick(() => {
                  this.submitAlipayForm(res.data.form);
                });
                
                // 开始轮询检查支付状态（用户支付完成后可以看到状态更新）
                setTimeout(() => {
                  this.startPolling();
                }, 3000);
              } 
              // 微信支付：显示二维码对话框
              else if (this.rechargeForm.paymentType === 1) {
                this.$message.success('订单创建成功，请扫码支付');
                
                // 显示支付对话框
                this.paymentDialogVisible = true;
                
                // 生成二维码
                this.$nextTick(() => {
                  this.generateQRCode(res.data.codeUrl);
                });
                
                // 开始轮询检查支付状态
                this.startPolling();
              } 
              // 银联支付：直接提交表单跳转到银联页面
              else if (this.rechargeForm.paymentType === 3) {
                this.$message.success('订单创建成功，即将跳转到银联支付页面...');
                
                // 渲染并自动提交银联表单
                this.$nextTick(() => {
                  this.submitPaymentForm(res.data.form);
                });
                
                // 开始轮询检查支付状态（用户支付完成后可以看到状态更新）
                setTimeout(() => {
                  this.startPolling();
                }, 3000);
              }
            } else {
              this.$message.error(res.msg || '创建订单失败');
            }
          } catch (error) {
            // console.error('创建订单失败:', error);
            this.$message.error('创建订单失败，请稍后重试');
          } finally {
            this.rechargeLoading = false;
          }
        } else {
          this.$message.warning('请填写完整的充值信息');
          return false;
        }
      });
    },
    
    // 提交支付宝表单
    submitAlipayForm(formHtml) {
      // 创建一个临时的 div 来容纳表单
      const div = document.createElement('div');
      div.innerHTML = formHtml;
      document.body.appendChild(div);
      
      // 获取表单并提交
      const form = div.querySelector('form');
      if (form) {
        // 自动提交表单，跳转到支付宝支付页面
        form.submit();
        
        // 提交后可以移除div（虽然页面会跳转）
        setTimeout(() => {
          document.body.removeChild(div);
        }, 1000);
      } else {
        this.$message.error('支付表单加载失败，请重试');
        document.body.removeChild(div);
      }
    },
    
    // 提交支付表单（通用方法，用于银联等需要跳转的支付方式）
    submitPaymentForm(formHtml) {
      // 创建一个临时的 div 来容纳表单
      const div = document.createElement('div');
      div.innerHTML = formHtml;
      document.body.appendChild(div);
      
      // 获取表单并提交
      const form = div.querySelector('form');
      if (form) {
        // 自动提交表单，跳转到支付页面
        form.submit();
        
        // 提交后可以移除div（虽然页面会跳转）
        setTimeout(() => {
          if (document.body.contains(div)) {
            document.body.removeChild(div);
          }
        }, 1000);
      } else {
        this.$message.error('支付表单加载失败，请重试');
        document.body.removeChild(div);
      }
    },
    
    // 生成二维码（微信支付）
    generateQRCode(codeUrl) {
      // 清空之前的二维码
      if (this.$refs.qrcode) {
        this.$refs.qrcode.innerHTML = '';
      }
      
      // 生成新的二维码
      new QRCode(this.$refs.qrcode, {
        text: codeUrl,
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    
    // 检查支付状态
    startPolling() {
      this.pollingCount = 0;
      this.pollingMessage = '支付完成后会自动跳转...';
      
      // // 每3秒检查一次，最多检查60次（3分钟）
      // this.pollingTimer = setInterval(() => {
      //   this.pollingCount++;
      //
      //   if (this.pollingCount > 60) {
      //     this.stopPolling();
      //     this.pollingMessage = '支付超时，请手动查询支付状态';
      //     return;
      //   }
      //
      //   this.checkPaymentStatus(true);
      // }, 3000);
    },
    
    // 停止轮询
    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
      this.pollingCount = 0;
    },

    // 查询支付状态（轮询）
    async checkPaymentStatus(silent = false) {
      if (!this.currentOrder) return;

      try {
        const res = await request.get('/payment/order/query', {
          params: { orderNo: this.currentOrder.orderNo }
        });

        if (res.code === '200') {
          const status = res.data.status;

          if (status === 1) { // 支付成功
            this.stopPolling();
            this.$message.success('支付成功！');
            this.paymentDialogVisible = false;
            // 刷新交易记录和账户信息
            this.loadTransactionRecords();
            // 可以选择跳转到个人中心
            setTimeout(() => {
              this.$router.push('/center');
            }, 1500);
          } else if (status === 2) { // 已取消
            this.stopPolling();
            this.$message.warning('订单已取消');
            this.paymentDialogVisible = false;
            this.loadTransactionRecords();
          } else if (status === 0){
            this.$message.info('订单未支付，请完成支付');
          }
          // else if (status === 3) { // 已退款
          //   this.stopPolling();
          //   this.$message.info('订单已退款');
          //   this.paymentDialogVisible = false;
          //   this.loadTransactionRecords();
          // }
          else if (!silent) {
            this.$message.info('订单待支付，请完成支付');
          }
        } else if (!silent) {
          this.$message.error(res.msg || '查询订单状态失败');
        }
      } catch (error) {
        // console.error('查询订单状态失败:', error);
        if (!silent) {
          this.$message.error('查询订单状态失败');
        }
      }
    },
    
    // 取消订单
    async cancelOrder(orderId) {
      this.$confirm('确定要取消此订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await request.post('/payment/order/cancel', null, {
            params: { orderNo: orderId }
          });
          
          if (res.code == 200) {
            this.$message.success('订单已取消');
            this.loadTransactionRecords();
          } else {
            this.$message.error(res.msg || '取消订单失败');
          }
        } catch (error) {
          // console.error('取消订单失败:', error);
          this.$message.error('取消订单失败');
        }
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },
    
    // 取消当前支付订单
    async cancelCurrentOrder() {
      if (!this.currentOrder) return;
      
      this.$confirm('确定要取消支付吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await request.post('/payment/order/cancel', null, {
            params: { orderNo: this.currentOrder.orderNo }
          });
          
          if (res.code == 200) {
            this.$message.success('订单已取消');
            this.stopPolling();
            this.paymentDialogVisible = false;
            this.loadTransactionRecords();
          } else {
            this.$message.error(res.msg || '取消订单失败');
          }
        } catch (error) {
          // console.error('取消订单失败:', error);
          this.$message.error('取消订单失败');
        }
      }).catch(() => {
        // 用户点击了取消按钮
      });
    },
    
    // 查询订单状态（从交易记录中）
    async checkOrderStatus(orderNo) {
      try {
        const res = await request.get('/payment/order/query', {
          params: { orderNo: orderNo }
        });
        
        if (res.code == 200) {
          const statusMap = {
            0: '待支付',
            1: '已支付',
            2: '已取消',
            3: '已退款'
          };
          const statusText = statusMap[res.data.status] || '未知状态';
          
          this.$message.info(`订单状态：${statusText}`);
          
          // 如果状态改变，刷新交易记录
          if (res.data.status !== 0) {
            this.loadTransactionRecords();
          }
        } else {
          this.$message.error(res.msg || '查询订单失败');
        }
      } catch (error) {
        // console.error('查询订单失败:', error);
        this.$message.error('查询订单失败');
      }
    },
    
    // 获取订单状态类型（用于el-tag样式）
    getStatusType(status) {
      const statusMap = {
        '1': 'success',
        '0': 'warning',
        '2': 'info'
      };
      return statusMap[status] || 'info';
    }
  }
}
</script>

<style scoped>
.recharge-page {
  padding: 40px 30px;
  min-height: 100vh;
  max-width: 1400px;
  margin: 0 auto;
  background: #f5f7fa;
}

.header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.recharge-title {
  font-size: 28px;
  font-weight: 700;
  margin: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.box-card {
  margin-bottom: 24px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

.package-info {
  background-color: #f5f7fa;
  padding: 15px;
  border-radius: 4px;
}

.package-info p {
  margin: 8px 0;
  line-height: 1.6;
}

/* 支付对话框样式 */
.payment-dialog-content {
  text-align: center;
}

.payment-info {
  background-color: #f5f7fa;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
  text-align: left;
}

.payment-info p {
  margin: 8px 0;
  line-height: 1.8;
}

.qrcode-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 250px;
  margin: 20px 0;
}

.qrcode-wrapper {
  text-align: center;
}

#qrcode {
  display: inline-block;
  padding: 10px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.payment-tips {
  background-color: #ecf5ff;
  border: 1px solid #b3d8ff;
  color: #409EFF;
  padding: 10px 15px;
  border-radius: 4px;
  margin-top: 20px;
}

.payment-tips i {
  margin-right: 5px;
}
</style>

